import React, { useContext, useEffect, useRef, useState } from "react";

import { Box, Tooltip } from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import { green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { LocalSee } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import DoneIcon from "@material-ui/icons/Done";
import MicIcon from "@material-ui/icons/Mic";
import NoteIcon from "@material-ui/icons/Note";
import PersonIcon from "@material-ui/icons/Person";
import ReplayIcon from "@material-ui/icons/Replay";
import VisibilityIcon from "@material-ui/icons/Visibility";
import clsx from "clsx";
import { useHistory, useParams } from "react-router-dom";

import {
	formatMessageCalendarDay,
	formatMessageClock,
	isMessageSameLocalDay,
	isMessageYesterday,
} from "../../helpers/dateTimeFormat";
import TailwickContactAvatar from "../ChatLayout/TailwickContactAvatar";

import { AuthContext } from "../../context/Auth/AuthContext";
import { useBusinessTimezone } from "../../context/BusinessTimezone/BusinessTimezoneContext";
import toastError from "../../errors/toastError";
import apiV2 from "../../services/apiV2";
import { emitTicketRealtime } from "../../helpers/ticketRealtimeEvents";
import { i18n } from "../../translate/i18n";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import MarkdownWrapper from "../MarkdownWrapper";
import { Status } from "../Status";
import TicketListItemTailwick from "./TicketListItemTailwick";

const useStyles = makeStyles((theme) => ({
	lastMessageSpan: {
		display: "flex",
		alignItems: "center",
		gap: 4,
		marginBottom: 4,
	},

	lastMessageIcon: {
		fontSize: "1.1em",
	},

	ticket: {
		position: "relative",
		marginBottom: 5,
		borderRadius: 20,
		overflow: "hidden"
	},

	pendingTicket: {
		cursor: "unset",
	},

	noTicketsDiv: {
		display: "flex",
		height: "100px",
		margin: 40,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},

	noTicketsText: {
		textAlign: "center",
		color: "rgb(104, 121, 146)",
		fontSize: "14px",
		lineHeight: "1.4",
	},

	noTicketsTitle: {
		textAlign: "center",
		fontSize: "16px",
		fontWeight: "600",
		margin: "0px",
	},

	contactNameWrapper: {
		display: "flex",
		justifyContent: "space-between",
	},

	lastMessageTime: {
		fontSize: "0.8em",
		justifySelf: "flex-end",
	},

	tagsBox: {
		position: "absolute",
		top: 53,
		left: 75,
		right: theme.spacing(1),
		display: "flex",
		flexDirection: "row",
		flexWrap: "nowrap",
		gap: 4,
		fontWeight: 500,
		alignItems: "center",
		overflow: "hidden",
		minWidth: 0,
		maxHeight: 22,
		pointerEvents: "none",
		zIndex: 1,
	},

	tag: {
		color: "#fff",
		fontSize: "0.7em",
		padding: "0 6px",
		borderRadius: "20px",
		textShadow: "0 0 3px #000",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: 88,
		flexShrink: 1,
		minWidth: 0,
	},

	tagOverflow: {
		color: "#fff",
		fontSize: "0.7em",
		padding: "0 6px",
		borderRadius: "20px",
		textShadow: "0 0 2px #000",
		whiteSpace: "nowrap",
		flexShrink: 0,
		backgroundColor: "rgba(0,0,0,0.35)",
		border: "1px solid rgba(255,255,255,0.25)",
	},

	lastUnreadMessageTime: {
		fontSize: "0.8em",
		color: "#3d8c40",
		justifySelf: "flex-end",
	},

	closedBadge: {
		alignSelf: "center",
		justifySelf: "flex-end",
		marginRight: 32,
		marginLeft: "auto",
	},

	contactLastMessage: {
		paddingRight: 20,
	},

	newMessagesCount: {
		alignSelf: "center",
		marginRight: 8,
		marginLeft: "auto",
	},

	bottomButton: {
		top: "12px",
	},

	badgeStyle: {
		color: "white",
		backgroundColor: green[500],
	},

	acceptButton: {
		position: "absolute",
		left: "50%",
	},

	ticketQueueColor: {
		flex: "none",
		width: "10px",
		height: "200px",
		position: "absolute",
		left: "0%",
		borderRadius: "50%"
	},

	//Marca vermelha do lado do contato

	userTag: {
		position: "absolute",
		marginRight: 5,
		right: 20,
		top: 12,
		// bottom: 30,
		backgroundColor: theme.palette.background.default,
		color: theme.palette.primary.main,
		border: "1px solid #CCC",
		padding: 1,
		paddingLeft: 5,
		paddingRight: 5,
		borderRadius: 10,
		fontSize: "0.9em",
	},

	contactAvatar: {
		width: 40,
		height: 40,
		minWidth: 40,
		minHeight: 40,
		borderRadius: "50%",
		backgroundColor: "#bdbdbd",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		overflow: "hidden",

		"& svg": {
			color: "#fff",
			fontSize: "2em",
		},
		"& img": {
			width: "100%",
			height: "100%",
			objectFit: "cover",
			display: "block",
		},
	},

	avatarSlot: {
		minWidth: 56,
		flexShrink: 0,
		display: "flex",
		alignItems: "center",
	},
	avatarWrap: {
		position: "relative",
		display: "inline-block",
	},
	channelIconOverlay: {
		position: "absolute",
		bottom: -4,
		right: -4,
		zIndex: 1,
		width: 22,
		height: 22,
		borderRadius: "50%",
		backgroundColor: "#fff",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
		boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
	},
}));

function TicketListItem({
	ticket,
	relatedTickets,
	tailwickLayout = false,
	bulkSelection = false,
	setBulkSelection,
	bulkSelected = [],
	setBulkSelected
}) {

	const classes = useStyles();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const { ticketId } = useParams();
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);
	const { timeZone: businessTimeZone } = useBusinessTimezone();
	const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] =
		useState(false);
	const [audioDuration, setAudioDuration] = useState("0:00");
	const userTagRef = useRef(null);
	const [userTagWidth, setUserTagWidth] = useState(0);
	const [status, setStatus] = useState(false);

	const lastUpdate = ticket.lastMessageObj?.createdAt || ticket.updatedAt;

	const getAudioDuration = (media) => {
		const audio = new Audio(media);
		audio.onloadedmetadata = () => {
			if (audio.readyState > 0) {
				const minutes = Math.floor(audio.duration / 60);
				const seconds = Math.floor(audio.duration - minutes * 60);
				const secondsWithZero = seconds < 10 ? `0${seconds}` : seconds;
				setAudioDuration(`${minutes}:${secondsWithZero}`);
			}
		};
	};

	useEffect(
		() => () => {
			isMounted.current = false;
		},
		[]
	);

	useEffect(() => {
		const handleResize = () => {
			if (userTagRef.current && userTagRef.current.offsetWidth > 0) {
				if (ticket.status === "pending") {
					setUserTagWidth(userTagRef.current.offsetWidth - 48);
				} else if (ticket.status === "closed") {
					setUserTagWidth(userTagRef.current.offsetWidth - 24);
				} else {
					setUserTagWidth(userTagRef.current.offsetWidth);
				}
			}
		};

		const observer = new ResizeObserver(handleResize);
		const tagNode = userTagRef.current;
		if (tagNode) {
			observer.observe(tagNode);
		}

		return () => {
			if (tagNode) {
				observer.unobserve(tagNode);
			}
		};
	}, [ticket.status]);

	const handleAcepptTicket = async (id) => {
		setLoading(true);
		try {
			const { data } = await apiV2.put(`/tickets/${id}`, {
				status: "open",
				userId: user?.id,
			});
			emitTicketRealtime({
				action: "update",
				ticket: data,
				previousStatus: ticket.status,
			});
			if (ticket.status !== data.status) {
				emitTicketRealtime({
					action: "delete",
					ticket: data,
					previousStatus: ticket.status,
				});
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
			return;
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};

	const queueName = (selectedTicket) => {
		let name = null;
		let color = null;
		user.queues &&
			user.queues.forEach((userQueue) => {
				if (userQueue.id === selectedTicket.queueId) {
					name = userQueue.name;
					color = userQueue.color;
				}
			});
		return {
			name,
			color,
		};
	};

	const handleOpenAcceptTicketWithouSelectQueue = () => {
		setAcceptTicketWithouSelectQueueOpen(true);
	};

	const handleReopenTicket = async (id) => {
		setLoading(true);
		try {
			const { data } = await apiV2.put(`/tickets/${id}`, {
				status: "open",
				userId: user?.id,
			});
			emitTicketRealtime({
				action: "update",
				ticket: data,
				previousStatus: "closed",
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
			return;
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};

	const handleViewTicket = async (id) => {
		history.push(`/tickets/${id}`);
	};

	const handleReturnTicket = async (id) => {
		setLoading(true);
		try {
			const { data } = await apiV2.put(`/tickets/${id}`, {
				status: "pending",
			});
			emitTicketRealtime({
				action: "update",
				ticket: data,
				previousStatus: ticket.status,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
			return;
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};


	function handleStatus() {
		setStatus(!status)
	}

	function timeOfStatus(duracao) {
		setTimeout(() => {
			setStatus(false);
		}, duracao * 1000);
	}

	const handleSelectTicket = (id) => {
		history.push(`/tickets/${id}`);
	};

	const generateLastMessage = (lastMessage, isGroup) => {
		let message = "";

		if (!lastMessage) {
			return (
				<span className={classes.lastMessageSpan}>
					<Typography
						noWrap
						component="span"
						variant="body2"
						color="textSecondary"
					>
						—
					</Typography>
				</span>
			);
		}

		if (!lastMessage?.fromMe && isGroup) {
			message += `${lastMessage?.contact?.name || ""}: `;
		} else if (lastMessage?.fromMe && isGroup) {
			message += "Você: ";
		}

		const body = typeof lastMessage.body === "string" ? lastMessage.body : "";

		// types: ogg, jpeg, png, webp, pdf

		if (lastMessage.mediaType === "audio") {
			return (
				<span className={classes.lastMessageSpan}>
					{message}
					<MicIcon className={classes.lastMessageIcon} />
					{getAudioDuration(lastMessage.mediaUrl)}

					{audioDuration}
				</span>
			);
		}
		if (
			body.endsWith(".jpeg") ||
			body.endsWith(".jpg") ||
			body.endsWith(".png") ||
			lastMessage.mediaType === "image"
		) {
			return (
				<span className={classes.lastMessageSpan}>
					{message}
					<LocalSee className={classes.lastMessageIcon} />
					Foto
				</span>
			);
		}
		if (body.endsWith(".pdf")) {
			return (
				<span className={classes.lastMessageSpan}>
					{message}
					<DescriptionIcon className={classes.lastMessageIcon} />
					{body}
				</span>
			);
		}
		if (body.endsWith(".webp")) {
			return (
				<span className={classes.lastMessageSpan}>
					{message}
					<NoteIcon className={classes.lastMessageIcon} />
					Figurinha
				</span>
			);
		}
		if (lastMessage.mediaType === "vcard") {
			const array = body.split("\n");
			const obj = [];
			let contact = "";
			for (let index = 0; index < array.length; index++) {
				const v = array[index];
				const values = v.split(":");
				for (let ind = 0; ind < values.length; ind++) {
					if (values[ind].indexOf("+") !== -1) {
						obj.push({ number: values[ind] });
					}
					if (values[ind].indexOf("FN") !== -1) {
						contact = values[ind + 1];
					}
				}
			}

			return (
				<span className={classes.lastMessageSpan}>
					<PersonIcon className={classes.lastMessageIcon} />
					{contact}
				</span>
			);
		}
		if (lastMessage.mediaType === "multi_vcard") {
			const array = body
				.replace("[{", "")
				.replace("}]", "")
				.split("},{");

			// array format: ['"id":66,"name":"Nathalia","number":"5527988882406"', '"id":12,"name":"Mãe Trabalho","number":"5527999996918"', '"id":72,"name":"Mariah Irmã","number":"5527997420098"']

			const contactsArray = array.map((item) => {
				const obj = {};
				item.split(",").forEach((i) => {
					const [key, value] = i.split(":");
					obj[key.replace('"', "").replace('"', "")] = value
						?.replace('"', "")
						.replace('"', "");
				});
				return obj;
			});

			return (
				<span className={classes.lastMessageSpan}>
					{message}
					<PersonIcon className={classes.lastMessageIcon} />
					{`${contactsArray[0]?.name || "Contato"} e outros ${
						Math.max(contactsArray.length - 1, 0)
					} contatos`}
				</span>
			);
		}

		return (
			<span className={classes.lastMessageSpan}>
				<Typography
					noWrap
					component="span"
					variant="body2"
					color="textSecondary"
				>
					{`${message}${body}`}
				</Typography>
			</span>
		);
	};

	const getTailwickMessagePreview = () => {
		const updatedAt = ticket.lastMessageObj?.createdAt || ticket.updatedAt;
		if (ticket.isStatus) {
			if (!updatedAt) return "Status publicado";
			if (isMessageSameLocalDay(updatedAt, new Date(), businessTimeZone)) {
				return `Postado: ${formatMessageClock(updatedAt, businessTimeZone)}`;
			}
			if (isMessageYesterday(updatedAt, new Date(), businessTimeZone)) {
				return "Postado: Ontem";
			}
			return `Postado: ${formatMessageCalendarDay(updatedAt, businessTimeZone)}`;
		}
		const msg = ticket.lastMessageObj;
		if (!msg) {
			return (ticket.lastMessage || "").replace(/<[^>]*>/g, "").trim();
		}
		if (msg.mediaType === "audio") return "Áudio";
		if (msg.mediaType === "image" || /\.(jpeg|jpg|png|webp)/i.test(msg.body || "")) {
			return "Foto";
		}
		if ((msg.body || "").endsWith(".pdf")) return "PDF";
		if (msg.mediaType === "vcard") return "Contato";
		if (msg.mediaType === "sticker" || (msg.body || "").endsWith(".webp")) return "Figurinha";
		return (msg.body || "").replace(/<[^>]*>/g, "").trim();
	};

	const getTailwickTimeLabel = () => {
		const updatedAt = ticket.lastMessageObj?.createdAt || ticket.updatedAt;
		if (!updatedAt) return "";
		if (isMessageSameLocalDay(updatedAt, new Date(), businessTimeZone)) {
			return formatMessageClock(updatedAt, businessTimeZone);
		}
		if (isMessageYesterday(updatedAt, new Date(), businessTimeZone)) {
			return "Ontem";
		}
		return formatMessageCalendarDay(updatedAt, businessTimeZone);
	};

	const tailwickContactName =
		ticket.channel !== "email"
			? ticket.contact?.name ?? ""
			: ticket.contact?.email ?? "";

	const tailwickDisplayName = ticket.contact?.company
		? `${tailwickContactName} (${ticket.contact.company})`
		: tailwickContactName;

	if (tailwickLayout) {
		const isActive = ticketId && +ticketId === ticket.id;
		return (
			<React.Fragment key={ticket.id}>
				<AcceptTicketWithouSelectQueue
					modalOpen={acceptTicketWithouSelectQueueOpen}
					onClose={() => setAcceptTicketWithouSelectQueueOpen(false)}
					ticketId={ticket.id}
				/>
				<TicketListItemTailwick
					ticket={ticket}
					isActive={isActive}
					contactName={tailwickDisplayName}
					lastMessagePreview={getTailwickMessagePreview()}
					timeLabel={ticket.isStatus ? "" : getTailwickTimeLabel()}
					unreadCount={ticket.unreadMessages || 0}
					queueColor={
						ticket.queue?.color || queueName(ticket)?.color || "#7C7C7C"
					}
					queueLabel={
						ticket.queue?.name ||
						queueName(ticket)?.name ||
						i18n.t("ticketsList.items.queueless")
					}
					connectionName={
						ticket.whatsappId ? ticket.whatsapp?.name ?? "" : ""
					}
					loading={loading}
					isPending={ticket.status === "pending"}
					onSelect={() => {
						if (ticket.status === "pending") return;
						if (ticket.isStatus === true) {
							handleStatus(ticket.id);
						} else {
							handleSelectTicket(ticket.id);
						}
					}}
					onAcceptNoQueue={(e) => {
						e.stopPropagation();
						handleOpenAcceptTicketWithouSelectQueue();
					}}
					onAccept={(e) => {
						e.stopPropagation();
						handleAcepptTicket(ticket.id);
					}}
					onView={(e) => {
						e.stopPropagation();
						handleViewTicket(ticket.id);
					}}
					bulkSelection={bulkSelection}
					bulkSelected={bulkSelected}
					setBulkSelected={setBulkSelected}
				/>
				{status && (
					<Status
						ticket={ticket}
						handleStatus={handleStatus}
						timeOfStatus={timeOfStatus}
						relatedTickets={
							relatedTickets?.length ? relatedTickets : [ticket]
						}
					/>
				)}
			</React.Fragment>
		);
	}

	return (
		<React.Fragment key={ticket.id}>
			<AcceptTicketWithouSelectQueue
				modalOpen={acceptTicketWithouSelectQueueOpen}
				onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
				ticketId={ticket.id}
			/>
			<Box
				style={
					tailwickLayout
						? { position: "relative" }
						: {
								position: "relative",
								paddingLeft: 10,
								paddingRight: 10,
								overflow: "hidden",
							}
				}
			>
				<ListItem
					dense
					button
					onClick={(e) => {
						if (ticket.status === "pending") return;
						if (ticket.isStatus === true) {
							handleStatus(ticket.id)
						} else {
							handleSelectTicket(ticket.id);
						}

					}}
					selected={ticketId && +ticketId === ticket.id}
					className={clsx(classes.ticket, {
						[classes.pendingTicket]: ticket.status === "pending",
						"tailwick-ticket-item": tailwickLayout,
						"tailwick-ticket-item--active": tailwickLayout && ticketId && +ticketId === ticket.id,
					})}
					style={tailwickLayout ? undefined : { minHeight: 72 }}
				>
					<Tooltip
						arrow
						placement="right"
						title={
							ticket.queue?.name ||
							queueName(ticket)?.name ||
							i18n.t("ticketsList.items.queueless")
						}
					>
						<span
							style={{
								backgroundColor:
									ticket.queue?.color || queueName(ticket)?.color || "#7C7C7C",
							}}
							className={classes.ticketQueueColor}
						/>
					</Tooltip>
					<div className={classes.avatarSlot}>
						<TailwickContactAvatar
							size="sm"
							contactId={ticket?.contact?.id}
							profilePicUrl={ticket?.contact?.profilePicUrl}
							isGroup={Boolean(ticket?.contact?.isGroup)}
							channel={ticket?.channel}
							contactChannel={ticket?.contact?.channel}
							statusHighlight={Boolean(ticket?.isStatus)}
							syncProfilePic={false}
						/>
					</div>
					<ListItemText
						disableTypography
						primary={
							<span className={classes.contactNameWrapper}>
								<Typography
									noWrap
									component="span"
									variant="body2"
									color="textPrimary"
								>
									{
										ticket.channel !== "email"
											? ticket.contact?.name ?? ""
											: ticket.contact?.email ?? ""
									}

									{
										ticket.contact?.company
											? ` (${ticket.contact?.company})`
											: null
									}
								</Typography>

								{ticket.lastMessage && (
									<Typography
										className={
											ticket.unreadMessages > 0
												? classes.lastUnreadMessageTime
												: classes.lastMessageTime
										}
										component="span"
										variant="body2"
										color="textSecondary"
										style={{
											marginRight: userTagWidth - 20,
										}}
									>
										{isMessageSameLocalDay(lastUpdate, new Date(), businessTimeZone) ? (
											<>{formatMessageClock(lastUpdate, businessTimeZone)}</>
										) : isMessageYesterday(lastUpdate, new Date(), businessTimeZone) ? (
											<>Ontem</>
										) : (
											<>{formatMessageCalendarDay(lastUpdate, businessTimeZone)}</>
										)}
									</Typography>
								)}

								{ticket.whatsappId && (
									<div
										ref={userTagRef}
										className={classes.userTag}
										title={i18n.t("ticketsList.connectionTitle")}
									>
										{ticket.whatsapp?.name ?? ""}
									</div>
								)}
							</span>
						}
						secondary={ticket.isStatus ?
							<span className={classes.contactNameWrapper}>
								<Typography
									className={classes.contactLastMessage}
									noWrap
									component="span"
									variant="body2"
									color="textSecondary"
								>
									Postado:{" "}
									{isMessageSameLocalDay(lastUpdate, new Date(), businessTimeZone) ? (
										<>{formatMessageClock(lastUpdate, businessTimeZone)}</>
									) : isMessageYesterday(lastUpdate, new Date(), businessTimeZone) ? (
										<>Ontem</>
									) : (
										<>{formatMessageCalendarDay(lastUpdate, businessTimeZone)}</>
									)}

								</Typography>

							</span>

							:

							<span className={classes.contactNameWrapper}>
								<Typography
									className={classes.contactLastMessage}
									noWrap
									component="span"
									variant="body2"
									color="textSecondary"
								>
									{ticket.lastMessageObj ? (
										// <MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper>
										generateLastMessage(ticket.lastMessageObj, ticket?.isGroup)
									) : ticket.lastMessage ? (
										<MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper>
									) : (
										<br />
									)}
								</Typography>

								<Badge
									overlap="rectangular"
									className={classes.newMessagesCount}
									badgeContent={ticket.unreadMessages}
									classes={{
										badge: classes.badgeStyle,
									}}
								/>
							</span>
						}
					/>
					{ticket.status === "pending" &&
						(ticket.queue === null || ticket.queue === undefined) && (
							<Tooltip title={i18n.t("ticketsList.items.accept")}>
								<IconButton
									className={classes.bottomButton}
									color="primary"
									onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
									loading={loading.toString()}
								>
									<DoneIcon />
								</IconButton>
							</Tooltip>
						)}
					{ticket.status === "pending" && ticket.queue !== null && (
						<Tooltip title={i18n.t("ticketsList.items.accept")}>
							<IconButton
								className={classes.bottomButton}
								color="primary"
								onClick={(e) => handleAcepptTicket(ticket.id)}
							>
								<DoneIcon />
							</IconButton>
						</Tooltip>
					)}
					{ticket.status === "pending" && (
						<Tooltip title={i18n.t("ticketsList.items.spy")}>
							<IconButton
								className={classes.bottomButton}
								color="primary"
								onClick={(e) => handleViewTicket(ticket.id)}
							>
								<VisibilityIcon />
							</IconButton>
						</Tooltip>
					)}

					{ticket.status === "open" && (
						<Tooltip title={i18n.t("ticketsList.items.reopen")}>
							<IconButton
								className={classes.bottomButton}
								color="primary"
								onClick={(e) => handleReturnTicket(ticket.id)}
							>
								<ReplayIcon />
							</IconButton>
						</Tooltip>
					)}
					{ticket.status === "closed" && (
						<IconButton
							className={classes.bottomButton}
							color="primary"
							onClick={(e) => handleReopenTicket(ticket.id)}
						>
							<ReplayIcon />
						</IconButton>
					)}
					{ticket.status === "closed" && (
						<IconButton className={classes.bottomButton} color="primary" />
					)}

				</ListItem>
				<Box className={classes.tagsBox}>
					{ticket?.user &&

						<Tooltip title={"Atendente"} placement="top">
							<Box style={{
								marginLeft: 8, background: "grey", color: "#fff",
								fontSize: "0.7em",
								padding: "0 6px",
								borderRadius: "20px",
							}}
							>
								{ticket?.user ? ticket?.user.name : ""}
							</Box>
						</Tooltip>
					}
					{(() => {
						const seen = new Set();
						const tags = (ticket.contact?.tags || []).filter((tag) => {
							if (!tag) return false;
							const key = tag.id != null ? `id:${tag.id}` : `name:${tag.name}`;
							if (seen.has(key)) return false;
							seen.add(key);
							return true;
						});
						if (!tags.length) return null;

						const maxVisible = 2;
						const visible = tags.slice(0, maxVisible);
						const hidden = tags.slice(maxVisible);
						const hiddenTitle = hidden.map((t) => t.name).join(", ");
						return (
							<>
								{visible.map((tag, index) => (
									<Tooltip
										key={tag.id != null ? tag.id : `tag-${index}`}
										title={tag.name}
										placement="top"
									>
										<Box
											className={classes.tag}
											style={{ backgroundColor: tag.color }}
										>
											{tag?.name}
										</Box>
									</Tooltip>
								))}
								{hidden.length > 0 && (
									<Tooltip title={hiddenTitle} placement="top">
										<Box className={classes.tagOverflow} component="span">
											+{hidden.length}
										</Box>
									</Tooltip>
								)}
							</>
						);
					})()}
				</Box>

				{status &&
					<Status ticket={ticket} handleStatus={handleStatus} timeOfStatus={timeOfStatus} relatedTickets={relatedTickets?.length ? relatedTickets : [ticket]} />
				}



			</Box>
		</React.Fragment>
	);
}

export default TicketListItem;
